import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { MessageCircleMore, X } from 'lucide-react';

import type { PersonalManagerV1 } from '@/shared/api';

import { getSupportNavigation } from '../config';

export function WorkspaceSupport({
	personalManager,
	onAction,
}: {
	personalManager?: PersonalManagerV1;
	onAction?: (action: string) => void;
}) {
	return (
		<Popover className="relative">
			{({ open, close }) => (
				<>
					<PopoverButton
						aria-label="Связаться с поддержкой"
						onClick={() => onAction?.(open ? 'support_close' : 'support_open')}
						className="flex size-9 shrink-0 items-center justify-center rounded-lg text-gray-3 transition-colors hover:bg-gray-5 hover:text-black data-[open]:bg-gray-4/60 data-[open]:text-gray-2 motion-reduce:transition-none"
					>
						<MessageCircleMore size={22} strokeWidth={1.5} aria-hidden="true" />
					</PopoverButton>
					<PopoverPanel
						className="absolute right-0 top-full z-50 mt-3 max-h-[calc(100svh-80px)] w-64 max-w-[calc(100vw-32px)] overflow-y-auto rounded-lg bg-white px-5 py-4 shadow-listbox ring-1 ring-inset ring-black/5"
						onKeyDown={(event) => {
							if (event.key === 'Escape') onAction?.('support_close');
						}}
					>
						{getSupportNavigation(personalManager).map((item, index) => (
							<div
								key={item.href}
								className="[&+div]:mt-4"
								onClickCapture={(event) => {
									if (
										event.target instanceof Element &&
										event.target.closest('a')
									)
										onAction?.(
											index === 0 ? 'support_manager' : 'support_founder',
										);
								}}
							>
								<h2 className="text-sm font-medium leading-5">{item.name}</h2>
								<p className="text-[11.2px] leading-5 text-gray-3">
									{item.hint}
								</p>
							</div>
						))}
						<button
							type="button"
							aria-label="Закрыть контакты поддержки"
							className="absolute right-1 top-1 flex size-5 items-center justify-center rounded-md text-gray-3 hover:bg-gray-5 hover:text-black"
							onClick={() => {
								onAction?.('support_close');
								close();
							}}
						>
							<X size={12} aria-hidden="true" />
						</button>
					</PopoverPanel>
				</>
			)}
		</Popover>
	);
}
